import { render, staticRenderFns } from "./CircularMailStatusCell.vue?vue&type=template&id=2e78bc14&scoped=true&"
import script from "./CircularMailStatusCell.vue?vue&type=script&lang=babel&"
export * from "./CircularMailStatusCell.vue?vue&type=script&lang=babel&"
import style0 from "./CircularMailStatusCell.vue?vue&type=style&index=0&id=2e78bc14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e78bc14",
  null
  
)

export default component.exports